import baseapi from "./../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";


export const DashboardAPI = async (setFreshLeadCount, setTotalCount, setLoading, setNotifications) =>
{
    setLoading(true);    

    try 
    {

        const [freshcount, totalcount, followupdata] = await Promise.all([
                                                                      baseapi.get("/api/publisher/dashboard/fresh-lead-count"),
                                                                      baseapi.get("/api/publisher/dashboard/total-lead-count"),
                                                                      baseapi.get("/api/publisher/dashboard/today-followup"),
                                                                ]);
        
        setLoading(false);

        console.log(freshcount.data.datacount);
        setFreshLeadCount(freshcount.data.datacount);
        setTotalCount(totalcount.data.datacount);
        setNotifications(followupdata.data.datalist);
        
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}

/*export const DashboardAPI = async (setTodayLeadCount, setTotalLeadCount, setWeekLeadCount, setMonthLeadCount, setDuplicateLeadCount, setLoading) =>
{
    setLoading(true);    

    try 
    {
        const response = await baseapi.get("/api/publisher/dashboard");

        //console.log("Data got successfully", response.data);
        
        setTodayLeadCount(response.data.leadcount.todaycount);
        setTotalLeadCount(response.data.leadcount.totalcount);
        setWeekLeadCount(response.data.leadcount.weekcount);
        setMonthLeadCount(response.data.leadcount.monthcount);
        setDuplicateLeadCount(response.data.leadcount.duplicatecount);
        

        setLoading(false);
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}*/

